import { BaseEntity } from 'yt-ng-framework';

export class Chart extends BaseEntity {
    Date: string = null;
    Ukupno: number = null;
    Broj: number = null;

    Deserialize(input: any){
        this.Date = input.date;
        this.Ukupno = input.ukupno;
        this.Broj = input.broj ? input.broj : 0;

        return this;
    }

    Serialize(input: any){
        return input;
    }
}